<button
  role="tab"
  class="tab px-3"
  [class.active]="tab.active"
  (click)="onClick()"
  [attr.aria-selected]="tab.active"
  [attr.aria-controls]="controls"
  
  type="button"
  [disabled]="disabled"
  [id]="'tab-button-' + tab.id"
>
  <shrd-uic-svg-icon
    *ngIf="icon"
    [icon]="icon"
    [title]="iconTitle"
    size="small"
    class="icon pe-1 d-none d-md-block"
  ></shrd-uic-svg-icon>
  <div class="tab-label text-uppercase">
    <ng-content></ng-content>
  </div>
  <div class="tab-border" *ngIf="tab.active"></div>
</button>
